'use client';

import { Checkbox } from '@/shadcn/ui/checkbox';
import { Button } from '@/shadcn/ui/button';
import {
  useCookiePreferences,
  ConsentCategory,
  useCookieBanner,
} from 'cookiebanner-finally';

export function CookieSettings() {
  const { isVisible, acceptAll, denyAll, show, close } = useCookieBanner();
  const { preferences, updateCategory } = useCookiePreferences();

  return (
    <div className="cookie-settings bg-black/40 backdrop-blur-[.5rem] w-full p-[4rem] flex flex-col gap-[3.25rem] lg:gap-[4.5rem] text-left">
      <div className="flex flex-col gap-[1rem]">
        <h2 className="text-white font-inter-tight uppercase text-[3rem] lg:text-[4rem]">
          Cookie Settings
        </h2>

        <p className="font-inter-tight text-offwhite text-[2rem] leading-relaxed">
          We use cookies and other technologies to ensure the functionality of our website and to analyze user behavior. More information can be found in the privacy policy.
        </p>
      </div>

      <div className="flex flex-col gap-[2rem]">
        <div className="flex items-start gap-4">
          <div className="flex flex-col gap-3 flex-1">
            <h3 className="text-white font-inter-tight text-[2.5rem] lg:text-[3rem]">
              Marketing
            </h3>
            <p className="font-inter-tight text-offwhite text-[1.75rem] leading-relaxed">
              These cookies make advertising more relevant and measure the effectiveness of campaigns.
            </p>
          </div>
          <Checkbox
            className="w-[1.75rem] h-auto aspect-square translate-y-[.2rem] border-white/50 data-[state=checked]:bg-white data-[state=checked]:text-black"
            id="marketing"
            checked={preferences.marketing}
            onCheckedChange={(e) =>
              //@ts-ignore
              updateCategory(ConsentCategory.Marketing, e)
            }
          />
        </div>

        <div className="w-full h-[1px] bg-white/[15%]"></div>

        <div className="flex items-start gap-4">
          <div className="flex flex-col gap-3 flex-1">
            <h3 className="text-white font-inter-tight text-[2.5rem] lg:text-[3rem]">
              Personalization
            </h3>
            <p className="font-inter-tight text-offwhite text-[1.75rem] leading-relaxed">
              These cookies save your preferences and settings (e.g. language, region) and offer extended, personalized features.
            </p>
          </div>
          <Checkbox
            className="w-[1.75rem] h-auto aspect-square translate-y-[.2rem] border-white/50 data-[state=checked]:bg-white data-[state=checked]:text-black"
            id="preferences"
            checked={preferences.preferences}
            onCheckedChange={(e) =>
              //@ts-ignore
              updateCategory(ConsentCategory.Preferences, e)
            }
          />
        </div>

        <div className="w-full h-[1px] bg-white/[15%]"></div>

        <div className="flex items-start gap-4">
          <div className="flex flex-col gap-3 flex-1">
            <h3 className="text-white font-inter-tight text-[2.5rem] lg:text-[3rem]">
              Analytics
            </h3>
            <p className="font-inter-tight text-offwhite text-[1.75rem] leading-relaxed">
              These cookies collect anonymous information that helps us understand how our visitors use our website.
            </p>
          </div>
          <Checkbox
            className="w-[1.75rem] h-auto aspect-square translate-y-[.2rem] border-white/50 data-[state=checked]:bg-white data-[state=checked]:text-black"
            id="analytics"
            checked={preferences.analytics}
            onCheckedChange={(e) =>
              //@ts-ignore
              updateCategory(ConsentCategory.Analytics, e)
            }
          />
        </div>
      </div>

      <div className="flex lg:flex-row flex-col gap-4">
        <Button
          onClick={acceptAll}
          className="flex-1 border border-white/[15%] bg-white/5 hover:bg-white/[15%] transition-all duration-300 !w-full"
        >
          Accept all
        </Button>

        <Button
          onClick={denyAll}
          className="flex-1 text-offwhite/40 hover:opacity-75 transition-all duration-300 !w-full"
        >
          Reject all
        </Button>

        <Button
          onClick={close}
          className="flex-1 border border-white/[15%] hover:bg-white/5 transition-all duration-300 !w-full"
        >
          Save
        </Button>
      </div>
    </div>
  );
}
